export class Persona {
		rfc:                string;
		nombre:             string;
		apePaterno:         string;
		apeMaterno:         string;
		fechaStatus:        Date;
		estatus:            number;
		comentario:         string;
		claseAgente:        string;
		curp:               string;
		cveStat:            CveStat;
		usuario:            string;
		pass:               string;
		estaIngreso:        number;
		tipoIngreso:        number;
		fechaGeneraIngreso: Date;
		ingresoSeguro:      string;
	}
	
	export interface CveStat {
		claveStatus: number;
		descStatus:  string;
	}
	